var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 5.44451L17 1.00006V11.6667L1 8.11117V5.44451Z",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.64247 10.6C8.54908 10.9385 8.38994 11.2553 8.17411 11.5324C7.95829 11.8094 7.69002 12.0412 7.38462 12.2145C7.07922 12.3878 6.74267 12.4993 6.39418 12.5426C6.04569 12.5859 5.6921 12.5601 5.35358 12.4667C5.01506 12.3733 4.69825 12.2142 4.42123 11.9983C4.14422 11.7825 3.91243 11.5142 3.73909 11.2088C3.56576 10.9034 3.45427 10.5669 3.411 10.2184C3.36773 9.86991 3.39353 9.51631 3.48691 9.1778",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.c9d9717a8cba5f119819b3fc5bd8d69a.svg";
export { ForwardRef as ReactComponent };